<template>
  <div id="body_div">
    <div v-if="false" class="alert alert-warning alert-dismissible fade show text-center position-relative" role="alert" style="margin: 10px; padding: 15px; border-radius: 8px;">
      <div style="color: black;">
        <strong>Ci scusiamo per il problema che si è verificato...</strong><br />
        Ci vediamo giovedì!
      </div>

      <button type="button"
        class="btn-close position-absolute"
        aria-label="Close"
        @click="closeApologyBanner"
        style="top: 50%; right: 10px; transform: translateY(-50%);">
      </button>
    </div>

    <div id="app">
      <VerifyIdentity v-if="showVerify" :currentUser="currentUser" />

      <!-- Questionnaire invitation modal -->
      <div v-if="showQuestionnaireInvite" class="modal-overlay" style="z-index: 1100;">
        <div class="modal-content" style="width: 500px; max-width: 90%; height: auto; background-color:white !important; color:black !important;">
          <h4>Conosciamoci meglio</h4>
          <p>Compila il questionario per ottenere <b>20 punti</b>! La compilazione potrà avvenire durante tutta la settimana accedendo alla piattaforma.</p>
          <div class="d-flex justify-content-end mt-4">
            <button class="btn btn-dark me-2" @click="laterQuestionnaire">Più tardi</button>
            <button class="btn btn-primary" @click="startQuestionnaire">Compila Ora!</button>
          </div>
        </div>
      </div>

      <!-- Linear Questionnaire Flow -->
      <div v-if="activeQuestionnaires && !skipQuestionnaires">
        <!-- Step 1: Questionario Conoscitivo (only for students, buddies, developers) -->
        <QuestionarioConoscitivo
          v-if="currentStep === 'conoscitivo' && isNonTutor"
          :user="currentUser"
          @completed="moveToNextStep"
        />

        <!-- Step 2: Big5 Questionnaire -->
        <div v-if="currentStep === 'personality'" class="modal-overlay">
          <div class="modal-content">
            <!-- Big5 for non-tutors -->
            <Big5Questionnaire
              v-if="isNonTutor"
              :user="currentUser.id"
              @complete="handlePersonalityComplete"
            />

            <!-- Grid for tutors -->
            <GridQuestionnaire
              v-if="currentUser.role === 'tutor'"
              :user="currentUser.id"
              @complete="handlePersonalityComplete"
            />
          </div>
        </div>

        <!-- Step 3: Personality Results (only for students, buddies, developers) -->
        <div v-if="currentStep === 'results'" class="modal-overlay">
          <div class="modal-content">
            <PersonalityResults
              v-if="isNonTutor"
              :initialScores="scores"
            />
            <div class="d-flex justify-content-end mt-4">
              <button class="btn btn-primary" @click="moveToNextStep">Chiudi</button>
            </div>
          </div>
        </div>

        <!-- Steps 4-6: Post-experiment questionnaires (only if date is past reference date) -->
        <div v-if="isPastReferenceDate">
          <!-- Step 4: QuestionarioFinale for non-tutors -->
          <QuestionarioFinale
            v-if="currentStep === 'finale' && isNonTutor"
            :user="currentUser"
            @questionnaire-completed="moveToNextStep"
          />

          <!-- Step 5: QuestionarioFinaleGrid for tutors -->
          <QuestionarioFinaleGrid
            v-if="currentStep === 'finale' && currentUser.role === 'tutor'"
            :user="currentUser"
            @questionnaire-completed="moveToNextStep"
          />

          <!-- Step 6: DomandeRipetizioneFine for non-tutors -->
          <DomandeRipetizioneFine
            v-if="currentStep === 'ripetizione' && isNonTutor"
            :user="currentUser"
            @finished="finishAllQuestionnaires"
          />
        </div>
      </div>

      <!-- Show dashboard when not in questionnaire flow or when questionnaires are completed/skipped -->
      <UserDashboard
        v-if="showUserDashboard || skipQuestionnaires"
        :currentUser="currentUser"
      />

      <div v-else-if="!currentUser">
        Qualcosa è andato storto! Per favore, aggiorna la pagina.
      </div>
    </div>
    <GlobalLoading />
  </div>
</template>

<script>
import UserDashboard from "@/components/UserDashboard.vue";
import GlobalLoading from "@/components/GlobalLoading.vue";
import VerifyIdentity from "@/components/VerifyIdentity.vue";
import config from "@/utils/config";
import QuestionarioFinale from "./components/QuestionarioFinale.vue";
import QuestionarioFinaleGrid from "./components/QuestionarioFinaleGrid.vue";
import DomandeRipetizioneFine from "./components/DomandeRipetizioneFine.vue";
import QuestionarioConoscitivo from "./components/QuestionarioConoscitivo.vue";
import PersonalityResults from "./components/PersonalityResults.vue";
import Big5Questionnaire from "./components/Big5Questionnaire.vue";
import GridQuestionnaire from "./components/GridQuestionnaire.vue";

export default {
  name: 'App',
  components: {
    GlobalLoading,
    UserDashboard,
    VerifyIdentity,
    QuestionarioFinale,
    QuestionarioFinaleGrid,
    DomandeRipetizioneFine,
    QuestionarioConoscitivo,
    PersonalityResults,
    Big5Questionnaire,
    GridQuestionnaire,
  },
  data() {
    return {
      // User data
      currentUser: {
        id: '',
        role: '',
        fullName: '',
        age: '',
        formCompleted: false,
        finishedSperimentation: false,
        tutoringQuestions: false,
        afterValuationQuestionnaire: false,
        hasCompletedBig5: false
      },

      // Linear questionnaire flow management
      currentStep: null, // Current step in the questionnaire flow

      // Core application state
      showVerify: false,
      showUserDashboard: false,
      showApologyBanner: true,
      showQuestionnaireInvite: false,

      // Questionnaire management
      activeQuestionnaires: false,
      skipQuestionnaires: false,

      // Questionnaire data
      scores: null,

      // Date checking
      isPastReferenceDate: false,
    }
  },
  computed: {
    // Helper for detecting non-tutor roles
    isNonTutor() {
      return ['student', 'buddy', 'developer'].includes(this.currentUser.role);
    },

    // Determine which step user should be on based on their progress
    determinedStep() {
      // For new users who haven't completed the initial form
      if (!this.currentUser.formCompleted && this.isNonTutor) {
        return 'conoscitivo';
      }

      // For users who haven't completed Big5
      if (!this.currentUser.hasCompletedBig5) {
        return 'personality';
      }

      // For users who completed Big5 but haven't seen results (non-tutors only)
      if (this.currentUser.hasCompletedBig5 && !this.currentUser.afterValuationQuestionnaire && this.isNonTutor) {
        return 'results';
      }

      // For users who need to complete post-experiment questionnaires
      if (this.isPastReferenceDate && !this.currentUser.finishedSperimentation) {
        return 'finale';
      }

      // For users who need to complete ripetizione (after finale)
      if (this.isPastReferenceDate && this.currentUser.afterValuationQuestionnaire &&
          !this.currentUser.finishedSperimentation && this.isNonTutor) {
        return 'ripetizione';
      }

      // Default to null (completed all questionnaires)
      return null;
    }
  },
  methods: {
    closeApologyBanner() {
      this.showApologyBanner = false;
      localStorage.setItem("closedApologyBanner", "true");
    },

    // Linear questionnaire flow navigation
    moveToNextStep() {
      console.log(`Moving from step: ${this.currentStep}`);

      // Update user state based on completed step
      if (this.currentStep === 'conoscitivo') {
        this.currentUser.formCompleted = true;
        this.currentStep = 'personality';
      }
      else if (this.currentStep === 'personality') {
        // Handled by handlePersonalityComplete
      }
      else if (this.currentStep === 'results') {
        this.currentStep = this.isPastReferenceDate ? 'finale' : null;
        if (this.currentStep === null) {
          this.finishAllQuestionnaires();
        }
      }
      else if (this.currentStep === 'finale') {
        this.currentStep = this.isNonTutor ? 'ripetizione' : null;
        this.currentUser.afterValuationQuestionnaire = true;
        if (this.currentStep === null) {
          this.finishAllQuestionnaires();
        }
      }

      console.log(`Moved to step: ${this.currentStep}`);
    },

    // Handle Big5/Grid questionnaire completion
    handlePersonalityComplete(results) {
      this.scores = results;
      this.currentUser.hasCompletedBig5 = true;

      if (this.isNonTutor) {
        // For non-tutors, show results
        this.currentStep = 'results';
      } else {
        // For tutors, skip results and go to finale if past reference date
        this.currentStep = this.isPastReferenceDate ? 'finale' : null;
        if (this.currentStep === null) {
          this.finishAllQuestionnaires();
        }
      }
    },

    // Finish all questionnaires and show dashboard
    finishAllQuestionnaires() {
      this.currentUser.finishedSperimentation = true;
      this.activeQuestionnaires = false;
      this.currentStep = null;
      this.showUserDashboard = true;

      console.log("All questionnaires completed, showing dashboard");
    },

    // Start questionnaire flow
    startQuestionnaire() {
      this.showQuestionnaireInvite = false;
      this.activeQuestionnaires = true;
      this.showUserDashboard = false;

      // Set current step based on user progress
      this.currentStep = this.determinedStep;
      console.log(`Starting questionnaires at step: ${this.currentStep}`);

      // If all questionnaires are done, show dashboard
      if (this.currentStep === null) {
        this.showUserDashboard = true;
      }
    },

    // Later reminder for questionnaires
    laterQuestionnaire() {
      this.showQuestionnaireInvite = false;
      this.showUserDashboard = true;

      // Set a timestamp for the next reminder in localStorage
      const nextReminderTime = new Date();
      nextReminderTime.setMinutes(nextReminderTime.getMinutes() + 90); // Remind after 90 minutes
      localStorage.setItem('questionnaire-reminder-time', nextReminderTime.toISOString());
    },

    // Check if user has incomplete questionnaires
    hasIncompleteQuestionnaires() {
      // Non-tutor without completed initial form
      if (!this.currentUser.formCompleted && this.isNonTutor) {
        return true;
      }

      // Anyone without Big5 completed
      if (!this.currentUser.hasCompletedBig5) {
        return true;
      }

      // Post-experiment questionnaires not completed
      if (this.isPastReferenceDate && !this.currentUser.finishedSperimentation) {
        return true;
      }

      return false;
    },

    // Check URL parameters and fetch user data
    async checkURLParams() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('verify')) {
        if (!sessionStorage.getItem("verifying")) {
          sessionStorage.setItem("verifying", urlParams.get('verify'));
          window.location.reload();
          return;
        }
        this.currentUser.id = urlParams.get('verify');
        this.showVerify = true;
      } else {
        try {
          const response = await fetch(config.baseUrl + '/user/current', {
            method: 'GET',
            credentials: 'include',
            headers: { 'Accept': 'application/json' }
          });
          const userData = await response.json();
          this.currentUser = {
            ...userData,
            id: parseInt(userData.id),
          };
          console.log("Current user data:", this.currentUser);
          this.showVerify = false;

          // Convert age to integer
          this.currentUser.age = parseInt(userData.age);

          // Check if we're past the reference date
          const now = new Date();
          const referenceDate = new Date("2025-05-12T14:00:00");
          console.log("Current date:", now);
          console.log("Reference date:", referenceDate);
          this.isPastReferenceDate = now >= referenceDate;
          console.log("Is past reference date:", this.isPastReferenceDate);

          // By default, show the dashboard
          this.showUserDashboard = true;

          // Check for incomplete questionnaires after a short delay
          setTimeout(() => {
            if (this.hasIncompleteQuestionnaires()) {
              this.showQuestionnaireInvite = true;
            }
          }, 1000);

          // Check for existing reminder in localStorage
          const reminderTimeString = localStorage.getItem('questionnaire-reminder-time');
          if (reminderTimeString) {
            const reminderTime = new Date(reminderTimeString);
            const now = new Date();

            // Check if the reminder time has passed
            if (now >= reminderTime) {
              // Clear the reminder
              localStorage.removeItem('questionnaire-reminder-time');

              // Show the questionnaire invitation after a short delay
              setTimeout(() => {
                this.showQuestionnaireInvite = true;
              }, 3000);
            }
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      }
    }
  },
  mounted() {
    this.checkURLParams();

    const closedBanner = localStorage.getItem("closedApologyBanner");
    console.log("Closed banner:", closedBanner);
    this.showApologyBanner = !closedBanner;
  }
}
</script>

<style>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #333;
  z-index: 1000;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 10px;
}

/* Modal Content */
.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  width: 80%;
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* Pulsante di chiusura */
.close-button {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
  transition: color 0.2s ease-in-out;
}

.close-button:hover {
  color: #ff5f5f;
}

/* Skip questionnaire container */
.skip-questionnaire-container {
  width: 100%;
  padding: 15px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.skip-questionnaire-container button {
  padding: 8px 16px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.skip-questionnaire-container button:hover {
  background-color: #e0e0e0;
}

.custom-btn {
  min-width: 70px; /* Imposta una larghezza minima per uniformare le dimensioni */
  height: 35px; /* Imposta un'altezza fissa per uniformare le dimensioni */
  line-height: 1.5; /* Regola l'altezza della linea per l'allineamento del testo */
  text-align: center; /* Allinea il testo al centro */
  margin-right: 3px;
}

.clickable {
  cursor: pointer; /* Cambia il cursore per indicare che è cliccabile */
}

.underline {
  position: relative;
}

.underline::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px; /* Distanza dal testo */
  height: 1px; /* Spessore della sottolineatura */
  transition: all 0.3s ease; /* Transizione per un effetto più fluido */
  opacity: 0; /* Inizialmente invisibile */
}

.underline.active::after {
  opacity: 1; /* Rendi visibile la sottolineatura quando attiva */
}

.modal-content {
  background-color: var(--bs-modal-bg) !important;
}
</style>